import React from "react";
import OptionButtons from "./OptionButtons";

class PreFlopAggressionBase extends React.Component {

    render() {
        return (<div>
            <OptionButtons buttonArray={[
                { name: "Learn Post-Flop Aggression", onclickMethod: this.props.learnMore },
                {
                    name: "View Your Hands",
                    onclickMethod: this.props.seeMoreHands,
                    disabled: !this.props.isHandsAvailable,
                },
            ]} />
        </div>)
    }
}

export default PreFlopAggressionBase;


/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/PreFlopAggressionBase.js
 **/